export const StatusProva: Array<{label: string, value: number }> = [
    { label: 'Não Inscrito',                        value: 1 },
    { label: 'Inscrito para Prova',                 value: 2 },
    { label: 'Aprovado',                            value: 3 },
    { label: 'Reprovado',                           value: 4 },
    { label: 'Faltou / Reprovado',                  value: 5 }
];